import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import './style.scss';
import { faTrashCanList, faXmark } from '@fortawesome/pro-regular-svg-icons';
import lodash, { update } from 'lodash';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from "primereact/confirmdialog";
import { PersonalScoringApi } from "../../../services/personalScoring/api";
import { Configuration as PersonalScoringApiConfiguration } from "../../../services/personalScoring/configuration"
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";

// eslint-disable-next-line react/display-name
const ListBar = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const personalScoringApi = new PersonalScoringApi(new PersonalScoringApiConfiguration({ basePath: process.env.REACT_APP_PERSONAL_SCORING_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_PERSONAL_SCORING_API_BASE_PATH));

    const [selectedListId, setselectedListId] = useState(undefined);
    const [selectedListName, setselectedListName] = useState(undefined);
    const [deleteConfirmModalShow, setMdeleteConfirmModalShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [editModalShow, setEditModalShow] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');
    const [listsData, setListsData] = useState([]);
    const [activeCustomListButton, setActiveCustomListButton] = useState("predefinedxu030.SNE7uSuy");
    const [editRenameInputValue, setEditRenameInputValue] = useState('');
    const [visibleAlert, setVisibleAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const toast = useRef(null);

    let defaultListItem = [
        {
            "Id": 0,
            "Name": "BIST 30",
            "Type": "SystemXU030",
            "Symbols": [],
            "EntityID": 0
        },
        {
            "Id": 1,
            "Name": "Listem 1",
            "Type": "SystemXXXX",
            "Symbols": [],
            "EntityID": 0
        },
    ];

    // const apiConf = useSelector(state => state.api.config);
    // const api = new MainApi(new Configuration({ basePath: process.env.REACT_APP_WATCHLIST_API_BASE_PATHß }));

    useImperativeHandle(ref, () => ({
        updateList(listName) {
            getList(listName);
        },
        deSelect() {
            setActiveCustomListButton(undefined);
        }

    }));

    useEffect(() => {
        getList("");
    }, []);

    useEffect(() => {
        
        if (listsData.length <= 0) {
            
            props.listStatus('empty');
        }
        else {
            props.listStatus('something');
        }
    }, [listsData]);


    const createListHandler = () => {
        // api.apiMainNewPost(inputValue, user['TokenId'], []).then((res) => {
        //  // console.log(res);
        //   setModalShow(false);
        //   setInputValue('');
        //   dispatch(setCreated(true));
        // });
    };

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    const handleEditRenameChange = (e) => {
        setEditRenameInputValue(e.target.value);
    };

    const editListHandler = () => {
        // api.apiMainRenameGet(selectedListId, inputValue, user['TokenId'], []).then((res) => {
        //  // console.log(res);
        //   setEditModalShow(false);
        //   setInputValue('');
        //   dispatch(setCreated(true));
        // });
    };

    const confirmedDeleteListHandler = () => {
        // api.apiMainDeleteGet(selectedListId, user['TokenId'], []).then((res) => {
        //  // console.log(res);
        //   setInputValue('');
        //   setMdeleteConfirmModalShow(false);
        //   dispatch(setCreated(true));
        // });
        

        deleteList();
    };

    const confirmDeleteListCancelHandler = () => {
        setInputValue('');
        setMdeleteConfirmModalShow(false);
    };

    //#region Functions

    const clickCustomListButton = (id, name) => {
        setActiveCustomListButton(id);
        setselectedListId(id);
        setselectedListName(name);

        let item = listsData.find((item) => { return item.id === id });

        if (item) {
            props.selectedListBarItem(item, true);
        }
        else {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('listNotFound'), life: 3000 });
        }

    };

    const clickEdit = (id, name) => {
        // setselectedListId(id);
        setEditModalShow(true);
        setEditRenameInputValue(name);
        // console.log(' activeCustomListButton::' + activeCustomListButton);
    };

    const deleteListAccept = () => {
        setVisibleAlert(true);
        setAlertMessage("'" + selectedListName + "' İsimli listeyi silmek istediğinize emin misiniz?");
    };

    const deleteListreject = () => {
    };

    //#endregion Functions

    //#region  API CALL

    const getList = (lastCreatedListName) => {


        personalScoringApi.apiPersonalscoringPagecustomlistesPost(token).then((res) => {
            // console.log(res);

            // dispatch(setWatchlist(res.data.items));
            const mappedListData = lodash.map(res.data, (res, index) => ({
                name: res.listName,
                id: res.id,
                order: index,
                count: "-",
                ...res
            })).sort((a, b) => new Date(a.createDateTime).getTime() - new Date(b.createDateTime).getTime());

            if (mappedListData.length === 0) {
                return;
            }

            setListsData(mappedListData);

            if (lastCreatedListName) {
                let lastAddedItem = mappedListData.find((item) => { return item.name === lastCreatedListName });

                if (lastAddedItem) {
                    props.selectedListBarItem(lastAddedItem, true);
                    setActiveCustomListButton(lastAddedItem.id);
                }
            }
            else {

                props.selectedListBarItem(mappedListData[1]);

                // setActiveCustomListButton(mappedListData[1].id);
            }
        }).catch((err) => {
            // console.log(err);
        });
    }

    const createList = () => {

        const culture = "tr-TR";
        const name = inputValue;
        const symbols = [];

        if (inputValue == "") {
            toast.current.show({
                severity: 'warn',
                summary: t('warning'),
                detail: t('personalSorting.emptyListName'),
                life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
            });
            return;
        }

        personalScoringApi.apiPersonalscoringAddpagecustomlistPost(token, name).then((res) => {
            // console.log(res);

            if (!res.data.error) {

                setModalShow(false);
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: "'" + name + "' isimli izleme listesi başarıyla oluşturuldu",
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });
                getList(name);
            }
            else {
                toast.current.show({
                    severity: 'error',
                    summary: t('unsuccessful'),
                    detail: "Hata: " + res.data.error,
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });
            }

        }).catch((err) => {
            toast.current.show({
                severity: 'error',
                summary: t('unsuccessful'),
                detail: "Hata: " + err,
                life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
            });
            // console.log(err);
        });
    }

    const clickEditRenameList = () => {
        const culture = "tr-TR";
        const prevName = selectedListName;
        const newName = editRenameInputValue;
        const id = selectedListId;

        personalScoringApi.apiPersonalscoringRenamepagecustomlistPost(token, id, newName).then((res) => {
            // console.log(res);

            if (!res.data.error) {

                setModalShow(false);
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: "'" + prevName + "' '" + newName + "' ile değiştirildi.",
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });
                getList();
                setEditModalShow(false);
            }
            else {
                toast.current.show({
                    severity: 'error',
                    summary: t('unsuccessful'),
                    detail: "Hata: " + res.data.error,
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });
            }


        }).catch((err) => {
            // console.log(err);
        });

    }

    const deleteList = () => {
        

        const culture = "tr-TR";
        const id = selectedListId;
        const name = selectedListName;
        personalScoringApi.apiPersonalscoringDeletepagecustomlistPost(token, id).then((res) => {
            // console.log(res);

            if (!res.data.error) {
                setListsData([]);
                setModalShow(false);
                toast.current.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: "'" + name + "' listesi silindi.",
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });

                getList();
                setEditModalShow(false);

            }
            else {
                toast.current.show({
                    severity: 'error',
                    summary: t('unsuccessful'),
                    detail: "Hata: " + res.data.error,
                    life: 3000, // Toast mesajının ekranda kalma süresi (ms cinsinden)
                });
            }
        }).catch((err) => {
            // console.log(err);
        });

    }

    //#endregion API CALLS

    return (
        <div className='list-bar-component'>
            <Toast ref={toast} position="bottom-right" />
            <ConfirmDialog
                visible={visibleAlert}
                onHide={() => setVisibleAlert(false)}
                message={alertMessage}
                header="Uyarı"
                icon="pi pi-exclamation-triangle"
                accept={deleteList}
                reject={deleteListreject}
                acceptLabel={t('yes')}
                rejectLabel={t('cancel')}
            />
            {/* <div className="edit-buttons-row"> */}
            <Container className=''>
                <Row className='m-t-20' >
                    {listsData.map((item) => (
                        <Col key={item.id} md="auto">
                            <Row>
                                <div className='watchlist-buttons-col'>
                                    <div
                                        className={`custom-list-buttons button roboto-bold-14 ${activeCustomListButton === item.id ? "active" : ""}`}
                                        onClick={() => clickCustomListButton(item.id, item.name)}>
                                        <label className='title'>
                                            {item.name}
                                        </label>
                                        <div className="edit-button" onClick={() => clickEdit(item.id, item.name)}>
                                            <FontAwesomeIcon className="icon" icon={faPencil} />
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Col>
                    ))}
                    {/* 
                    <div className="add-button" onClick={() => setModalShow(true)}>
                        <FontAwesomeIcon className='icon text-align-right float-right cursor-pointer' icon={faPlus} />
                    </div> */}

                </Row>
            </Container>
            {/* <CustomListModal customListButtonSave={customListButtonSave} /> */}
            {/* </div> */}


            {/* <Container>
        <Row className="w-list-row">
          {watchlists && watchlists.map((item, idx) => (
            <Col xs="auto" className="p-r-0" key={item.Id}>
              <div className="w-list-item">
                <div className="w-list-item__title">
                  <span className="item__title">{item.Name}</span>{' '}
                </div>
                <div className="w-list-item__count">
                  {item.Type !== 'SystemXU030' && (
                    <span className="item__count">{item.Symbols.length}</span>
                  )}
                  {item.Type == 'SystemXU030' && (
                    <span className="item__count">30</span>
                  )}

                </div>
                {item.Type !== 'SystemXU030' && (
                  <div className="w-list-item__edit">
                    <div className="icon-wrapper">
                      <FontAwesomeIcon icon={faPencil} onClick={() => editHandle(item.Id)} />
                    </div>
                  </div>
                )}
              </div>
            </Col>
          ))}

          <Col xs="auto" className="p-r-0">
            <div className="w-list-item__add">
              <div className="item__add" onClick={() => setModalShow(true)}>
                <FontAwesomeIcon icon={faPlus} />
              </div>
            </div>
          </Col>
        </Row>
      </Container> */}
            <Modal dialogClassName="modal-delete-confirm-list" show={deleteConfirmModalShow} aria-labelledby="contained-delete-confirm-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Body>

                    <Row>
                        <Col>
                            <div className="delete-confirm-body">
                                <div className="delete-confirm-trash-icon">
                                    <FontAwesomeIcon icon={faTrashCanList} />
                                </div>
                                <span className="m-t-15">{selectedListName}</span>
                                <span>{t('personalSorting.removeWatchListQuestion')}</span>
                            </div>
                        </Col>
                    </Row>

                    <Row className="modal-delete-confirm-buttons m-t-30">
                        <Col>
                            <Button onClick={confirmDeleteListCancelHandler} className="cancel-btn hl-btn">
                                {t('cancel')}
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={confirmedDeleteListHandler} className="hl-primary-btn hl-btn">
                                {t('delete')}
                            </Button>
                        </Col>
                    </Row>

                </Modal.Body>
            </Modal>

            <Modal dialogClassName="modal-edit-list" show={editModalShow} aria-labelledby="contained-edit-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="modal-header-wrap">
                            <h6 className="m-0">{t('editList')}</h6>
                            <div
                                className="modal-header-close"
                                onClick={() => {
                                    setEditModalShow(false);
                                    setInputValue('');
                                }}
                            >
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="form-group">
                                <input data-testid="listName-input" type="text" value={editRenameInputValue} onChange={handleEditRenameChange} className="form-control listName-input input" id="listName-input" placeholder="Liste Adı" />
                            </div>
                        </Col>
                    </Row>
                    <Button onClick={clickEditRenameList} className="modal-save-btn save-button">
                        {t('save')}
                    </Button>

                    <Button onClick={deleteListAccept} className="modal-delete-list-btn cancel-button">
                        {t('deleteList')}
                    </Button>
                </Modal.Body>
            </Modal>

            <Modal dialogClassName="modal-create-list" show={modalShow} aria-labelledby="contained-modal-title-vcenter" animation={true} backdrop="static" keyboard={false} centered>
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="modal-header-wrap">
                            <h6 className="m-0">{t('personalSorting.creatNewWatchList')}</h6>
                            <div className="modal-header-close" onClick={() => setModalShow(false)}>
                                <FontAwesomeIcon icon={faXmark} />
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <div className="form-group" data-testid="listName-input">
                                <input type="text" value={inputValue} onChange={handleChange} className="form-control input" id="listName-input" placeholder="Liste Adı" />
                            </div>
                        </Col>
                    </Row>
                    <Button onClick={createList} className="modal-save-btn save-button">
                        {t('save')}
                    </Button>
                </Modal.Body>
            </Modal>


        </div>
    );
});

export default ListBar;
